import Cookies from "js-cookie";
import HELPERS from "./helper";

export const IsTokenValid = () => {
  const accessToken = Cookies.get("access_token");
  const refreshToken = Cookies.get("refresh_token");

  if (accessToken) {
    return true;
  }

  if (refreshToken) {
    HELPERS.refreshAccessToken(refreshToken).catch(() => {});
    return true;
  }

  return false;
};
